import { render, staticRenderFns } from "./AddBirthdayNotice.vue?vue&type=template&id=48cde9a4&"
import script from "./AddBirthdayNotice.vue?vue&type=script&lang=js&"
export * from "./AddBirthdayNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports